import belowTheFold from 'video/belowTheFold';
import setVideoPrivacyModalHandler from '../setVideoPrivacyModalHandler';
import { trackAction } from '../../helpers/trackingOM';

belowTheFold(
    CBS.Registry.region.prefix +
        '/shows/{slug}/video/xhr/episodes/page/{page}/size/{size}/xs/{excludeShow}/season/{season}/',
    CBS.Registry.region.prefix +
        '/shows/{slug}/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/xs/0/',
);
document.addEventListener('DOMContentLoaded', function () {
    setVideoPrivacyModalHandler();
});

window.addEventListener('load', () => {
    if (document.getElementById('vpnErrorSlate') !== null) {
        const payload = {
            appLogText:
                'It looks like you’re using a VPN or proxy, which prevents playing your video. Please disable this service and try again. ',
            appLogType: 'VPN Proxy Detection',
            appLogCode: 'No code provided',
        };
        trackAction('trackAppLog', payload);
    }
});
